import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthForm from '../components/AuthForm';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [isLogin, setIsLogin] = useState(false);

  // Redirect to dashboard if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const toggleMode = () => {
    setIsLogin(!isLogin);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-stone-50 to-orange-50 py-8 flex items-center justify-center">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="max-w-md mx-auto bg-white rounded-2xl shadow-lg p-10 border border-stone-200">
            <h1 className="text-4xl font-black mb-8 font-['Space_Grotesk'] bg-gradient-to-r from-emerald-600 via-teal-600 to-orange-500 bg-clip-text text-transparent text-center">
              {isLogin ? 'Welcome Back' : 'Create Your Account'}
            </h1>
            <p className="text-stone-600 text-center mb-8 font-['Inter']">
              {isLogin 
                ? 'Log in to save your progress and access additional features'
                : 'Start tracking your Mounjaro journey with precise dose management and cost optimization'}
            </p>
            <AuthForm isLogin={isLogin} onToggleMode={toggleMode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
